import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppSettingsService, ArrayResponse, BaseRestService, SendBackResult} from '../../shared';
import {Rules} from '../models/rules';

@Injectable({providedIn: 'root'})
export class RulesService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'RulesService'; }

  protected get isAnonymous(): boolean { return false; }


  add(contractUuid: string, rules: Rules): Observable<SendBackResult<Rules>> {
    return this.post<Rules>(`/Contract/${contractUuid}/Rule`, rules);
  }
  load(contractUuid: string): Observable<SendBackResult<ArrayResponse<Rules>>> {
    return this.get<ArrayResponse<Rules>>(`/Contract/${contractUuid}/Rules`);
  }

  update(contractUuid: string, rules: Rules): Observable<SendBackResult<Rules>> {
    return this.put<Rules>(`/Contract/${contractUuid}/Rule`, rules);
  }
}
